import axiosInstance from "./axios";
import { SupClass } from "./models/supClass.models";

const apiUrl = import.meta.env.VITE_BACKEND_API_URL;

export const fetchSupClasses = async (bearerToken): Promise<SupClass[]> => {
  try {
    const response = await axiosInstance.get(
      `${apiUrl}/Report/reports/supclass`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch supclasses:", error);
    throw error;
  }
};
